module.exports = __webpack_public_path__ + "static/media/icon-email-open.7af9c380.svg";